import { useFeatureFlags } from './useFeatureFlags.tsx';

export const useEnableArenaClassicRooms = () => {
  const {
    flags: { enableArenaClassicRooms = false },
  } = useFeatureFlags();

  return !!enableArenaClassicRooms;
};
